import React from 'react'
import quote from './quote.png'
import { Jumbotron } from 'reactstrap'
import './about.css'

var Translate = require('react-translate-component')

export default class About extends React.Component {
  constructor () {
    super()
    this.state = {
      width: window.innerWidth
    }
  }

  componentWillMount () {
    window.addEventListener('resize', this.handleWindowSizeChange)
  }

  // make sure to remove the listener
  // when the component is not mounted anymore
  componentWillUnmount () {
    window.removeEventListener('resize', this.handleWindowSizeChange)
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth })
  }
  render () {
    return (
      <Jumbotron id='jumbotronAbout'>
        {this.state.width > 768 && (
          <img src={quote} id='quoteImg' alt='quote' />
        )}
        <div className='aboutUsText'>
          <p className='sectionTitle'>
            <Translate content='kim_jestesmy' />
          </p>
          <hr className='sectionTitleLine' />
          <p className='aboutUsDesc'>
            <Translate content='jestesmy_firma' />
          </p>
          <p className='bold aboutUsSign'>
            <Translate content='wlasciciel_firmy' />
          </p>
          <p className=' aboutUsSign'>Tomasz Dębek</p>
        </div>
      </Jumbotron>
    )
  }
}
